/** Where the API is served; same-origin unless set (the dev server proxies /api). */
export const API_ORIGIN: string =
  import.meta.env.VITE_API_ORIGIN || window.location.origin;
